import axios from "axios";
import { useState } from "react";
import ListBlogs from "./components/ListBlogs";
import { useDispatch, useSelector } from "react-redux";
import { appendBlogsRedux, setAllBlogsRedux, setBlogsLoadingRedux, setSelectedBlogPageRedux, updateSelectedBlogData } from "../../Store/slices/blogSlice";
import AddNewBlog from "./components/AddNewBlog";
import toast from "react-hot-toast";
import DeleteBlog from "./components/DeleteBlog";
import UpdateBlog from "./components/UpdateBlog";
import { storage } from "../../firebaseConfig";
import { ref, uploadBytesResumable, getDownloadURL, uploadBytes } from 'firebase/storage';
import { RootState } from "../../Store/store";

export const useBlogsHook = () => {
    const { selectedBlogPage, blogsLoading } = useSelector((state: any) => state.blogs.value);
    const [blogs, setBlogs] = useState<any>(null);
    const [lastBlogId, setLastBlogId] = useState<string | null>(null);
    const [loadingMore, setLoadingMore] = useState<boolean>(false);
    const [hasMoreBlogs, setHasMoreBlogs] = useState<boolean>(true);
    const dispatch = useDispatch();

    const {
        accessToken,
    } = useSelector((state: any) => state.auth.value);


    //Add New Blog States
    const [blogTitle1, setBlogTitle1] = useState('');
    const [blogDescription1, setBlogDescription1] = useState('');
    const [blogImage1, setBlogImage1] = useState('');
    const [blogTrimester, setBlogTrimester] = useState('');
    const [blogRecipeReferences, setBlogRecipeReferences] = useState<any[]>([]);
    const [blogTags, setBlogTags] = useState<any[]>([]);
    const [blogRelatedData, setBlogRelatedData] = useState<any[]>([]);
    const [blogTitle2, setBlogTitle2] = useState('');
    const [blogDescription2, setBlogDescription2] = useState('');
    const [blogImage2, setBlogImage2] = useState('');
    const [blogTitle3, setBlogTitle3] = useState('');
    const [blogDescription3, setBlogDescription3] = useState('');
    const [blogImage3, setBlogImage3] = useState('');

    const dropdownOptions = [
        {
            id: 1,
            label: 'Trimester 1',
            value: '1'
        },
        {
            id: 2,
            label: 'Trimester 2',
            value: '2'
        },
        {
            id: 3,
            label: 'Trimester 3',
            value: '3'
        },
        {
            id: 4,
            label: 'All',
            value: 'All'
        },
    ];

    const setSelectedBlogPage = (page: number) => {
        dispatch(setSelectedBlogPageRedux(page));
    };

    const setBlogsLoading = (loading: boolean) => {
        dispatch(setBlogsLoadingRedux(loading));
    };

    const BASE_URL = 'https://api.eatwellmama.com'

    const returnSelectedBlogPage = () => {
        switch (selectedBlogPage) {
            case 1: return <ListBlogs />;
            case 2: return <AddNewBlog />;
            case 3: return <UpdateBlog />;
            case 4: return <DeleteBlog />;
            default: return <ListBlogs />;
        }
    };

    const fetchAllBlogs = async () => {
        setBlogsLoading(true);
        setHasMoreBlogs(true);
        await axios.get(BASE_URL + "/api/blogs/getLast10BlogsByTrimester?blogTrimester=All")
            .then((response) => {
                console.log(response.data);
                let sortedDataByIsDeleted = response.data.data.sort((a: any, b: any) => {
                    return a.isDeleted === b.isDeleted ? 0 : a.isDeleted ? 1 : -1;
                });
                dispatch(setAllBlogsRedux(sortedDataByIsDeleted));
                setBlogs(sortedDataByIsDeleted);
                setLastBlogId(response.data.lastBlogId ?? null);
                setHasMoreBlogs(!!response.data.lastBlogId);
                setBlogsLoading(false);
            })
            .catch((error) => {
                console.log(error);
                setBlogsLoading(false);
                setBlogs(null);
                setLastBlogId(null);
            });
    };

    const fetchMoreBlogs = async () => {
        if (!lastBlogId || loadingMore || !hasMoreBlogs) return;

        setLoadingMore(true);
        await axios.get(BASE_URL + "/api/blogs/getMoreBlogsByTrimester", {
            params: {
                blogTrimester: "All",
                lastBlogId: lastBlogId,
            },
        })
            .then((response) => {
                const newBlogs = response.data.data ?? [];
                if (newBlogs.length > 0) {
                    let sortedDataByIsDeleted = newBlogs.sort((a: any, b: any) => {
                        return a.isDeleted === b.isDeleted ? 0 : a.isDeleted ? 1 : -1;
                    });
                    dispatch(appendBlogsRedux(sortedDataByIsDeleted));
                    setBlogs((prev: any) => prev ? [...prev, ...sortedDataByIsDeleted] : sortedDataByIsDeleted);
                }
                setLastBlogId(response.data.lastBlogId ?? null);
                setHasMoreBlogs(!!response.data.lastBlogId);
                setLoadingMore(false);
            })
            .catch((error) => {
                console.log(error);
                setLoadingMore(false);
            });
    };

    const searchBlogs = async (searchQuery: string) => {
        await axios.get(
            BASE_URL + '/api/blogs/searchBlogs',
            {
                params: {
                    searchQuery: searchQuery,
                },
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                }
            }
        ).then((response) => {
            console.log("SEARCH_BLOGS_RESPONSE:", response.data);
            let sortedDataByIsDeleted = response.data.data.sort((a: any, b: any) => {
                return a.isDeleted === b.isDeleted ? 0 : a.isDeleted ? 1 : -1;
            });
            dispatch(setAllBlogsRedux(sortedDataByIsDeleted));
            setBlogs(sortedDataByIsDeleted);
        }).catch((error) => {
            console.log("SEARCH_BLOGS_ERROR:", error);
        });
    };

    const { selectedBlogData, selectedBlogId } = useSelector((state: RootState) => state.blogs.value);

    const handleUpdate = async () => {
        if (
            !selectedBlogData.blogTitle1 ||
            !selectedBlogData.blogDescription1 ||
            !selectedBlogData.blogTrimester ||
            !selectedBlogData.blogTags ||
            !selectedBlogData.recipeReferences ||
            !selectedBlogData.relatedData
        )
            return toast.error('Please fill all the required fields!');

        setBlogsLoading(true);
        await axios.put(
            BASE_URL + '/api/blogs/updateBlog',
            {
                blogId: selectedBlogId,
                blogTitle1: selectedBlogData.blogTitle1,
                blogDescription1: selectedBlogData.blogDescription1,
                blogImage1: selectedBlogData.blogImage1 || '',
                blogTitle2: selectedBlogData.blogTitle2 === null ? '' : selectedBlogData.blogTitle2,
                blogDescription2: selectedBlogData.blogDescription2 === null ? '' : selectedBlogData.blogDescription2,
                blogImage2: selectedBlogData.blogImage2 || '',
                blogTitle3: selectedBlogData.blogTitle3 === null ? '' : selectedBlogData.blogTitle3,
                blogDescription3: selectedBlogData.blogDescription3 === null ? '' : selectedBlogData.blogDescription3,
                blogImage3: selectedBlogData.blogImage3 || '',
                blogTrimester: selectedBlogData.blogTrimester,
                blogTags: selectedBlogData.blogTags,
                recipeReferences: selectedBlogData.recipeReferences,
                relatedData: selectedBlogData.relatedData,
                isDeleted: selectedBlogData.isDeleted,
                isPriority: selectedBlogData.isPriority,
            },
            {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                }
            }
        ).then((response) => {
            console.log("UPDATE_BLOG_RESPONSE:", response.data);
            toast.success('Blog Updated Successfully');
            setBlogsLoading(false);
            setSelectedBlogPage(1)
        }).catch((error) => {
            console.log("UPDATE_BLOG_ERROR:", error);
            if (error.response.data.msg === 'Please fill all the required fields!') {
                toast.error('Missing Fields:' + JSON.stringify(error.response.data.field));
            }
            setBlogsLoading(false);
        });
    };

    const [file, setFile] = useState<any>(null);  // Fotoğraf dosyası
    const [uploading, setUploading] = useState<boolean>(false); // Yükleme durumu
    const [progress, setProgress] = useState<number>(0); // Yükleme ilerlemesi
    
    // Update için ayrı image upload state'leri
    const [updateUploading1, setUpdateUploading1] = useState<boolean>(false);
    const [updateProgress1, setUpdateProgress1] = useState<number>(0);
    const [updateUploading2, setUpdateUploading2] = useState<boolean>(false);
    const [updateProgress2, setUpdateProgress2] = useState<number>(0);
    const [updateUploading3, setUpdateUploading3] = useState<boolean>(false);
    const [updateProgress3, setUpdateProgress3] = useState<number>(0);

    const handleFileChange1 = async (event: any) => {
        toast.loading("Image loading...");
        const selectedFile = event.target.files[0];
        if (selectedFile) {
            setFile(selectedFile);
            console.log("Selected File =>", selectedFile);
            await handleUpload1(selectedFile);

        }
    };

    const handleFileChange2 = async (event: any) => {
        toast.loading("Image loading...");
        const selectedFile = event.target.files[0];
        if (selectedFile) {
            setFile(selectedFile);
            console.log("Selected File =>", selectedFile);
            await handleUpload2(selectedFile);

        }
    };

    const handleFileChange3 = async (event: any) => {
        toast.loading("Image loading...");
        const selectedFile = event.target.files[0];
        if (selectedFile) {
            setFile(selectedFile);
            console.log("Selected File =>", selectedFile);
            await handleUpload3(selectedFile);

        }
    };



    // Fotoğrafı Firebase'e yükleme
    const handleUpload1 = async (file_: any) => {
        console.log("File =>", file_);
        if (!file_) return;

        const storageRef = ref(storage, 'blogs/' + file_.name);
        const uploadTask = uploadBytesResumable(storageRef, file_);

        // Yükleme durumu takibi
        setUploading(true);
        uploadTask.on(
            'state_changed',
            (snapshot) => {
                // Yükleme ilerlemesi (isteğe bağlı)
                const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                console.log(`Upload is ${progress}% done`);
                setProgress(progress);
            },
            (error) => {
                console.error('Upload error:', error);
                setUploading(false);
            },
            () => {
                // Yükleme tamamlandığında URL'yi al
                getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
                    console.log('File available at', downloadURL);
                    setUploading(false);
                    setBlogImage1(downloadURL);
                    setTimeout(() => { toast.dismiss() }, 1000);
                    toast.success("Image loaded successfully");
                });
            }
        );

    };

    const handleUpload2 = async (file_: any) => {
        console.log("File =>", file_);
        if (!file_) return;

        const storageRef = ref(storage, 'blogs/' + file_.name);
        const uploadTask = uploadBytesResumable(storageRef, file_);

        // Yükleme durumu takibi
        setUploading(true);
        uploadTask.on(
            'state_changed',
            (snapshot) => {
                // Yükleme ilerlemesi (isteğe bağlı)
                const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                console.log(`Upload is ${progress}% done`);
                setProgress(progress);
            },
            (error) => {
                console.error('Upload error:', error);
                setUploading(false);
            },
            () => {
                // Yükleme tamamlandığında URL'yi al
                getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
                    console.log('File available at', downloadURL);
                    setUploading(false);
                    setBlogImage2(downloadURL);
                    setTimeout(() => { toast.dismiss() }, 1000);
                    toast.success("Image loaded successfully");
                });
            }
        );

    };

    const handleUpload3 = async (file_: any) => {
        console.log("File =>", file_);
        if (!file_) return;

        const storageRef = ref(storage, 'blogs/' + file_.name);
        const uploadTask = uploadBytesResumable(storageRef, file_);

        // Yükleme durumu takibi
        setUploading(true);
        uploadTask.on(
            'state_changed',
            (snapshot) => {
                // Yükleme ilerlemesi (isteğe bağlı)
                const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                console.log(`Upload is ${progress}% done`);
                setProgress(progress);
            },
            (error) => {
                console.error('Upload error:', error);
                setUploading(false);
            },
            () => {
                // Yükleme tamamlandığında URL'yi al
                getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
                    console.log('File available at', downloadURL);
                    setUploading(false);
                    setBlogImage3(downloadURL);
                    setTimeout(() => { toast.dismiss() }, 1000);
                    toast.success("Image loaded successfully");
                });
            }
        );

    };

    // Update için image upload fonksiyonları
    const handleUpdateFileChange1 = async (event: any) => {
        toast.loading("Blog Image 1 updating...");
        const selectedFile = event.target.files[0];
        if (selectedFile) {
            console.log("Selected File for Blog Update 1 =>", selectedFile);
            await handleUpdateUpload1(selectedFile);
        }
    };

    const handleUpdateUpload1 = async (file_: any) => {
        console.log("Update Blog File 1 =>", file_);
        if (!file_) return;

        const storageRef = ref(storage, 'blogs/' + file_.name);
        const uploadTask = uploadBytesResumable(storageRef, file_);

        setUpdateUploading1(true);
        uploadTask.on(
            'state_changed',
            (snapshot) => {
                const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                console.log(`Blog Update 1 Upload is ${progress}% done`);
                setUpdateProgress1(progress);
            },
            (error) => {
                console.error('Blog Update 1 Upload error:', error);
                setUpdateUploading1(false);
                toast.error('Blog Image 1 update failed');
            },
            () => {
                getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
                    console.log('Updated blog image 1 available at', downloadURL);
                    setUpdateUploading1(false);
                    
                    dispatch(updateSelectedBlogData({ key: "blogImage1", value: downloadURL }));
                    
                    setTimeout(() => { toast.dismiss() }, 1000);
                    toast.success("Blog Image 1 updated successfully");
                });
            }
        );
    };

    const handleUpdateFileChange2 = async (event: any) => {
        toast.loading("Blog Image 2 updating...");
        const selectedFile = event.target.files[0];
        if (selectedFile) {
            console.log("Selected File for Blog Update 2 =>", selectedFile);
            await handleUpdateUpload2(selectedFile);
        }
    };

    const handleUpdateUpload2 = async (file_: any) => {
        console.log("Update Blog File 2 =>", file_);
        if (!file_) return;

        const storageRef = ref(storage, 'blogs/' + file_.name);
        const uploadTask = uploadBytesResumable(storageRef, file_);

        setUpdateUploading2(true);
        uploadTask.on(
            'state_changed',
            (snapshot) => {
                const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                console.log(`Blog Update 2 Upload is ${progress}% done`);
                setUpdateProgress2(progress);
            },
            (error) => {
                console.error('Blog Update 2 Upload error:', error);
                setUpdateUploading2(false);
                toast.error('Blog Image 2 update failed');
            },
            () => {
                getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
                    console.log('Updated blog image 2 available at', downloadURL);
                    setUpdateUploading2(false);
                    
                    dispatch(updateSelectedBlogData({ key: "blogImage2", value: downloadURL }));
                    
                    setTimeout(() => { toast.dismiss() }, 1000);
                    toast.success("Blog Image 2 updated successfully");
                });
            }
        );
    };

    const handleUpdateFileChange3 = async (event: any) => {
        toast.loading("Blog Image 3 updating...");
        const selectedFile = event.target.files[0];
        if (selectedFile) {
            console.log("Selected File for Blog Update 3 =>", selectedFile);
            await handleUpdateUpload3(selectedFile);
        }
    };

    const handleUpdateUpload3 = async (file_: any) => {
        console.log("Update Blog File 3 =>", file_);
        if (!file_) return;

        const storageRef = ref(storage, 'blogs/' + file_.name);
        const uploadTask = uploadBytesResumable(storageRef, file_);

        setUpdateUploading3(true);
        uploadTask.on(
            'state_changed',
            (snapshot) => {
                const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                console.log(`Blog Update 3 Upload is ${progress}% done`);
                setUpdateProgress3(progress);
            },
            (error) => {
                console.error('Blog Update 3 Upload error:', error);
                setUpdateUploading3(false);
                toast.error('Blog Image 3 update failed');
            },
            () => {
                getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
                    console.log('Updated blog image 3 available at', downloadURL);
                    setUpdateUploading3(false);
                    
                    dispatch(updateSelectedBlogData({ key: "blogImage3", value: downloadURL }));
                    
                    setTimeout(() => { toast.dismiss() }, 1000);
                    toast.success("Blog Image 3 updated successfully");
                });
            }
        );
    };

    const addNewBlog = async () => {
        setBlogsLoading(true);
        const body = {
            blogTitle1: blogTitle1,
            blogDescription1: blogDescription1,
            blogImage1: blogImage1,
            blogTitle2: blogTitle2,
            blogDescription2: blogDescription2,
            blogImage2: blogImage2,
            blogTitle3: blogTitle3,
            blogDescription3: blogDescription3,
            blogImage3: blogImage3,
            blogTags: blogTags,
            blogTrimester: blogTrimester,
            recipeReferences: blogRecipeReferences,
            relatedData: blogRelatedData,
        };
        console.log("Body =>", body);
        console.log("Access Token =>", accessToken);


        await axios.post(
            BASE_URL + "/api/blogs/createNewBlog",
            body,
            {
                headers: {
                    'Authorization': `Bearer ${accessToken}`,
                },
            }
        )
            .then((response) => {
                console.log(response.data);
                toast.success('Blog Added Successfully');
                setBlogsLoading(false);
                dispatch(setSelectedBlogPageRedux(1));
            })
            .catch((error) => {
                console.log(error);
                toast.error('Error Adding Blog');
                setBlogsLoading(false);
            });
    };

    const deleteBlog = async (blogId: string) => {
        setBlogsLoading(true);
        await axios.post(
            BASE_URL + `/api/blogs/deleteBlog`,
            { blogId: blogId },
            {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            }
        )
            .then((response) => {
                console.log(response.data);
                toast.success('Blog Deleted Successfully');
                setBlogsLoading(false);
                fetchAllBlogs();
            })
            .catch((error) => {
                console.log(error);
                toast.error('Error Deleting Blog');
                setBlogsLoading(false);
            });
    };


    return {
        selectedBlogPage,
        setSelectedBlogPage,
        fetchAllBlogs,
        fetchMoreBlogs,
        searchBlogs,
        returnSelectedBlogPage,
        blogsLoading,
        blogs,
        loadingMore,
        hasMoreBlogs,
        blogTitle1,
        setBlogTitle1,
        blogDescription1,
        setBlogDescription1,
        blogImage1,
        setBlogImage1,
        blogTitle2,
        setBlogTitle2,
        blogDescription2,
        setBlogDescription2,
        blogImage2,
        setBlogImage2,
        blogTitle3,
        setBlogTitle3,
        blogDescription3,
        setBlogDescription3,
        blogImage3,
        setBlogImage3,
        handleFileChange1,
        handleFileChange2,
        handleFileChange3,
        blogTrimester,
        setBlogTrimester,
        blogRecipeReferences,
        setBlogRecipeReferences,
        blogRelatedData,
        setBlogRelatedData,
        dropdownOptions,
        addNewBlog,
        deleteBlog,
        file,
        uploading,
        setFile,
        setUploading,
        progress,
        blogTags,
        setBlogTags,
        handleUpdate,
        handleUpdateFileChange1,
        handleUpdateFileChange2,
        handleUpdateFileChange3,
        updateUploading1,
        updateProgress1,
        updateUploading2,
        updateProgress2,
        updateUploading3,
        updateProgress3,
    };
};